module.exports = __webpack_public_path__ + "static/img/doc_null.ee118b40.png";